import {injectable} from 'inversify'
import {toast, ToastOptions} from 'react-toastify'
import {
  INotificationService,
  NotificationPromiseMessages,
} from '@/src/ports/services/notification'

/**
 * Toast-based implementation of INotificationService
 *
 * Uses react-toastify under the hood.
 * Can be swapped with other implementations (e.g., Ant Design message)
 * or mocked for testing.
 */
@injectable()
export class ToastNotificationService implements INotificationService {
  success(message: string, options?: ToastOptions): void {
    toast.success(message, options)
  }

  error(message: string, options?: ToastOptions): void {
    toast.error(message, options)
  }

  warning(message: string, options?: ToastOptions): void {
    toast.warning(message, options)
  }

  info(message: string, options?: ToastOptions): void {
    toast.info(message, options)
  }

  promise<T>(
    promise: Promise<T>,
    messages: NotificationPromiseMessages,
  ): Promise<T> {
    return toast.promise(promise, {
      pending: messages.pending,
      success: messages.success,
      error: messages.error,
    })
  }
}
